module.exports = __webpack_public_path__ + "img/ubisell-logo.ec195260.png";